export default __webpack_public_path__ + "static/media/track.a449c259.svg";